<template>
	<div>
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name" size="sm" :model.sync="filter.name" />
					<b-form-group id="fieldset-is-enabled" label-cols-sm="4" label-cols-lg="3" label="Is Enabled" label-for="filter-is-enabled">
						<v-select append-to-body label="text" :options="isEnableds" :value="filter.isEnabled" :reduce="item => item.value" v-model="filter.isEnabled"></v-select>
					</b-form-group>
					<app-input-combobox-autocomplete :options="moduleInfos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Module Info" id="filter-" size="sm" :model.sync="filter.moduleInfoId" @input="getModuleInfos" @focus="getModuleInfos" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getFunctionInfos"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col v-if="false">
				<b-button variant="warning" v-if="(userRole != null ? userRole.allowUpload : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right" href="/files/FunctionInfo/FunctionInfo.xlsx" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button>
			</b-col>
		 </b-row>
		<b-card class="mt-3">
		<b-row class="mb-3">
			<b-col>
				<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/functioninfo/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				<b-overlay
					v-if="false"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="light"  :no-local-sorting="true" :items="functionInfos" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
			<template v-slot:head(actionss)>
				<b-button-group size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<!-- <b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button> -->
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Name">
					<b-form-input id="input-name-table" @input="getFunctionInfosWithoutLoading" v-model="filter.name" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="URL">
					<b-form-input id="input-uri-table" @input="getFunctionInfosWithoutLoading" v-model="filter.uri" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Icon Name">
					<b-form-input id="input-icon-name-table" @input="getFunctionInfosWithoutLoading" v-model="filter.iconName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Enabled">
					<v-select append-to-body label="text" :options="isEnableds" :value="filter.isEnabled" :reduce="item => item.value" v-model="filter.isEnabled" @input="getFunctionInfosWithoutLoading" ></v-select>
				</b-th>
				<b-th stacked-heading="Module Info">
					<v-select append-to-body label="name" :options="moduleInfos" :value="filter.moduleInfoId" :reduce="item => item.id" v-model="filter.moduleInfoId" :filterable="true" @input="getFunctionInfosWithoutLoading" @search="getModuleInfos"></v-select>
				</b-th>
				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(moduleInfo)="row">
				{{ row.item.moduleInfo != null ? row.item.moduleInfo.name : "" }}
			</template>
			<template v-slot:cell(isEnabled)="row">
				{{ row.item.isEnabled != null ? (row.item.isEnabled ? "Yes" : "No") : "" }}
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" :to="{path: '/functioninfo/edit/' + row.item.id }" variant ="success"  class="mr-2 btn-xs">
					<b-icon-pencil></b-icon-pencil>
				</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/functioninfo/detail/' + row.item.id }" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<b-button size="sm" v-if="false" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="false" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/functioninfo/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				<b-overlay
					v-if="false"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(functionInfosPaging != null ? functionInfosPaging.dataCount : 0)"
				:per-page="(functionInfosPaging != null ? functionInfosPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import FunctionInfo from '@/models/FunctionInfo/FunctionInfo';
import FunctionInfoList from '@/models/FunctionInfo/FunctionInfoList';
import FunctionInfoFilter from '@/filters/FunctionInfo/FunctionInfoFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import ModuleInfoFilter from '@/filters/ModuleInfo/ModuleInfoFilter';
import ModuleInfo from '@/models/ModuleInfo/ModuleInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {FunctionInfo, FunctionInfoList, FunctionInfoFilter, AppInputTextbox,AppInputTextarea,AppInputComboboxAutocomplete,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			isEnableds: [
				{ value: 0, text: 'Select All' },
				{ value: "true", text: 'True' },
          		{ value: "false", text: 'False' },
			],
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			isEnableds: [
				{ value : true, text : 'Yes' },
				{ value : false, text : 'No' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"actionss": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number"}}, 
				{"name": {}, "class" : "th-name", "label" : "Name", key: 'name', sortable: true}, 
				{"uri": {}, "class" : "th-uri", "label" : "URL", key: 'uri', sortable: true}, 
				{"iconName": {}, "class" : "th-icon-name", "label" : "Icon Name", key: 'iconName', sortable: true}, 
				{"isEnabled": {}, "class" : "th-is-enabled", "label" : "Is Enabled", key: 'isEnabled', sortable: true}, 
				{"moduleInfo": {}, "class" : "th-module-info", "label" : "Module Info", key: 'moduleName', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			functionInfos: [],
			functionInfosPaging: {},
			moduleInfos : [],
		}
	},
	methods : {
		getFunctionInfos : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			console.log(this.filter.isEnabled);
			FunctionInfo.getList(this, this.filter, this.sortingBy, this.currentPage, this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
					this.functionInfosPaging = result.pagination
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getFunctionInfosWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			FunctionInfo.getList(this, this.filter, this.sortingBy, this.currentPage, this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
					this.functionInfosPaging = result.pagination
				}
			})
			.catch(error => {});
		},
		getModuleInfos : async function(input) {
			let filter = new ModuleInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ModuleInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.moduleInfos = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new FunctionInfoFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getFunctionInfos();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				FunctionInfo.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			FunctionInfo.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			FunctionInfo.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		deleteData(id) {
			FunctionInfo.deleteData(this, id).then(result => {
				if (result)
				{
					this.getFunctionInfos();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new FunctionInfoFilter();
		this.getModuleInfos()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Function Info"
		];
		this.getFunctionInfos();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getFunctionInfos();
			}
		},
		sortDesc: {
			handler: function() {
				this.getFunctionInfos();
			}
		},
		currentPage: {
			handler: function() {
				this.getFunctionInfos();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getFunctionInfos();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				FunctionInfo.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "functioninfoindex") {
					this.getFunctionInfosWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "function_info").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
